import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ComponentProps } from "react";

/**
 * `next-themes` Next.js dan mustaqil ishlaydi — bu yerda faqat
 * `<html class="dark">` ni boshqaradi.
 *
 * `storageKey` `index.html` dagi inline skript bilan bir xil bo'lishi
 * SHART: u mavzuni birinchi bo'yashdan oldin qo'yadi va nomlar farq
 * qilsa, har yuklashda yorqin chaqnash bo'ladi.
 *
 * Faqat ikki mavzu: yorug' va qorong'i. "Tizim" varianti yo'q —
 * bitta tugma ikki holat orasida aniq almashadi.
 */
export function ThemeProvider({ children, ...props }: ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      attribute="class"
      themes={["light", "dark"]}
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="qd-admin-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
